<template>
	<div class="userinfo" :style="{height: `${windowHeight}px` }">
		<el-card>
			<el-tabs v-model="activetab" @tab-click="changeTab">
				<el-tab-pane :label="tab.name" :name="tab.name" v-for="tab in tabs" :key="tab.index">
					<resetpwd v-if="tab.index==0" ref="resetpwd"></resetpwd>
					<userparam v-if="tab.index==1" ref="userparam"></userparam>
				</el-tab-pane>
			</el-tabs>
		</el-card>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
import resetpwd from '@/components/user/resetpwd.vue';
import userparam from '@/components/user/userparam.vue';
export default {
	components: {
		resetpwd,
		userparam
	},
	data() {
		return {
			windowHeight: window.innerHeight - 120,
			tabs:[{index:0,name:'用户信息'},{index:1,name:'参数设置'}],
			activetab:'',
			activetabIndex:0,
		};
	},
	mounted() {

		this.activetab=this.tabs[this.activetabIndex].name;
	},
	methods:{
		changeTab(tab){
			var that=this;
			this.activetabIndex = tab.index;
			if(this.activetabIndex==1){
				that.$refs.userparam[0].init();
			}
		}
	}
};
</script>

<style></style>
